import { faFileSpreadsheet, faSync, faFilter, faExpandAlt, faPencil } from '@fortawesome/pro-light-svg-icons';
import { faFilter as faFilterSolid } from '@fortawesome/pro-solid-svg-icons';
import { SELECTION_CAP } from 'areas/search/hooks';
import { IAction } from './interfaces';
import { ColorPalette } from '../../config';

export const actions: IAction[] = [
  {
    displayName: 'Redigér i arbejdslistedesigner',
    id: 'EditInWorklistDesigner',
    isVisible: (selectedItemsCount, _isFeatureEnabled, _isTenantAddonEnabled, forceVisibility) => {
      const allowed = forceVisibility?.('EditInWorklistDesigner');
      const canEdit = allowed ?? true; // fallback keeps this change non-breaking
      return selectedItemsCount === 0 && canEdit;
    },
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
    icon: faPencil,
  },
  {
    displayName: 'Hent som regneark',
    id: 'Download',
    isVisible: selectedItemsCount => selectedItemsCount === 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
    icon: faFileSpreadsheet,
  },
  {
    displayName: 'Filtrér liste',
    id: 'FilterList',
    isVisible: selectedItemsCount => selectedItemsCount === 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
    icon: isFiltered => (isFiltered ? faFilterSolid : faFilter),
    iconColor: isFiltered => (isFiltered ? ColorPalette.HotAurora : undefined),
  },
  {
    displayName: 'Tilpas diagramstørrelse',
    id: 'AjustDiagramSize',
    isVisible: (selectedItemsCount, _isFeatureEnabled, _isFeaturePurchased, forceVisibility) => {
      const isForced = forceVisibility && forceVisibility('AjustDiagramSize');
      if (isForced !== undefined) {
        return isForced;
      }
      return selectedItemsCount === 0;
    },
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
    icon: faExpandAlt,
  },
  {
    id: 'RefreshList',
    displayName: 'Opdatér liste',
    isDisabled: (_selectedItemsCount, _rowCount, isLoading) => (isLoading ? 'Henter data' : ''),
    isVisible: _selectedItemsCount => true,
    icon: faSync,
  },
];
